import React from 'react';
import InfoBar from './components/InfoBar';
import Header from './components/Header';
import HomeSlider from './components/HomeSlider';
import About from './components/About';
import YogaSessions from './components/YogaSessions';
import Courses from './components/Courses';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import Testimonials from './components/Testimonials';
import Footer from './components/Footer';

function App() {
  return (
    <>
      {/* <InfoBar /> */}
      <Header />
      <HomeSlider />
      <About />
      <YogaSessions />
      <Courses />
      <Gallery />
      <Contact />
      <Testimonials />
      <Footer />
    </>
  );
}
export default App;